module.exports = __webpack_public_path__ + "img/jeep-upload.1a937402.svg";